import React from 'react';
import { EventRole } from 'src/imports/server-main/authorization.enum';
import Form from 'antd/lib/form';
import 'antd/lib/form/style/index.css';
import Select from 'antd/lib/select';
import 'antd/lib/select/style/index.css';
var ListUserEventRoleFilterRole = function (props) { return (React.createElement(Form.Item, { label: React.createElement("strong", null, "Search by role"), colon: false },
    React.createElement(Select, { size: 'large', allowClear: true, showSearch: true, style: { display: 'block' }, optionFilterProp: 'children', filterOption: function (input, option) { return option.props.children.toLowerCase().indexOf(input.toLowerCase()) >= 0; }, onChange: function (value) {
            props.setFilters({ filterRole: value });
        } },
        React.createElement(Select.Option, { value: EventRole.Organizer }, "Organizer"),
        React.createElement(Select.Option, { value: EventRole.Judge }, "Judge (Active)"),
        React.createElement(Select.Option, { value: EventRole.JudgePending }, "Judge (Request!)"),
        React.createElement(Select.Option, { value: EventRole.JudgeInactive }, "Judge (Inactive)"),
        React.createElement(Select.Option, { value: EventRole.Pending }, "Role request!"),
        React.createElement(Select.Option, { value: EventRole.Blocked }, "No Role")))); };
export default ListUserEventRoleFilterRole;



//////////////////
// WEBPACK FOOTER
// ./src/pages/WorkspaceEvent/ListUserEventRolePage/ListUserEventRoleFilterRole.tsx
// module id = 1042
// module chunks = 0